module.exports = __webpack_public_path__ + "img/icon-eye-open.107e183b.svg";